import React from 'react';
import './PrivacyPolicy.css';

interface PrivacyPolicyProps {
  onBack: () => void;
}

const PrivacyPolicy: React.FC<PrivacyPolicyProps> = ({ onBack }) => {
  return (
    <div className="privacy-policy">
      <div className="privacy-policy-header">
        <button className="back-button" onClick={onBack}>
          ← Back
        </button>
        <h1>Privacy Policy</h1>
      </div>
      
      <div className="privacy-policy-content">
        <div className="policy-section">
          <h2>1. Information We Collect</h2>
          <p>
            Remi AI collects information you provide directly to us, such as when you create an account, 
            use our services, or contact us for support. This may include:
          </p>
          <ul>
            <li>Name and contact information</li>
            <li>Business information and preferences</li>
            <li>Usage data and analytics</li>
            <li>Communication preferences</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>2. How We Use Your Information</h2>
          <p>We use the information we collect to:</p>
          <ul>
            <li>Provide, maintain, and improve our services</li>
            <li>Process transactions and send related information</li>
            <li>Send technical notices and support messages</li>
            <li>Respond to your comments and questions</li>
            <li>Develop new products and services</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>3. Information Sharing</h2>
          <p>
            We do not sell, trade, or otherwise transfer your personal information to third parties without 
            your consent, except as described in this policy. We may share your information:
          </p>
          <ul>
            <li>With service providers who assist us in operating our platform</li>
            <li>When required by law or to protect our rights</li>
            <li>In connection with a business transfer or acquisition</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>4. Data Security</h2>
          <p>
            We implement appropriate security measures to protect your personal information against 
            unauthorized access, alteration, disclosure, or destruction. This includes:
          </p>
          <ul>
            <li>Encryption of data in transit and at rest</li>
            <li>Regular security assessments and updates</li>
            <li>Access controls and authentication measures</li>
            <li>Employee training on data protection</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>5. Your Rights</h2>
          <p>You have the right to:</p>
          <ul>
            <li>Access and update your personal information</li>
            <li>Request deletion of your account and data</li>
            <li>Opt out of marketing communications</li>
            <li>Data portability in certain circumstances</li>
          </ul>
        </div>

        <div className="policy-section">
          <h2>6. Cookies and Tracking</h2>
          <p>
            We use cookies and similar technologies to enhance your experience, analyze usage patterns, 
            and provide personalized content. You can control cookie preferences through your browser settings.
          </p>
        </div>

        <div className="policy-section">
          <h2>7. Changes to This Policy</h2>
          <p>
            We may update this Privacy Policy from time to time. We will notify you of any changes by 
            posting the new policy on this page and updating the "Last Updated" date.
          </p>
        </div>

        <div className="policy-section">
          <h2>8. Contact Us</h2>
          <p>
            If you have any questions about this Privacy Policy or our data practices, please contact us at:
          </p>
          <p>
            Email: privacy@itsremi.ai<br />
            Address: [Your Business Address]
          </p>
        </div>

        <div className="policy-footer">
          <p><strong>Last Updated:</strong> {new Date().toLocaleDateString()}</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
